import {createAction} from '@reduxjs/toolkit';

/**
 * Señal de que el usuario cambió el país global (`CountryContext`). Los slices de
 * filtro que deban volver a su estado inicial reaccionan vía `extraReducers`.
 */
export const countryChanged = createAction('country/changed');
